import {MutableRefObject, useCallback, useEffect} from 'react';
import {useBlocker} from 'react-router-dom';

export const useReportNavigationGuard = (dirty: boolean, allowNavigation: MutableRefObject<boolean>) => {
  const shouldBlock = useCallback(() => dirty && !allowNavigation.current, [dirty, allowNavigation]);
  const blocker = useBlocker(shouldBlock);

  useEffect(() => {
    if (!dirty) return;
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (allowNavigation.current) return;
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [dirty, allowNavigation]);

  return blocker;
};
